module.exports = __webpack_public_path__ + "img/film-icon.a748fdd1.png";